import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

/**
 * Removes a co-host from an event
 */
export async function deleteCoHost(eventVaultId?: number, email?: string) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `deleteCoHost`.")
  if (!email)
    throw new Error("Missing Email: Unable to call `deleteCoHost`.")

  const endpoint = `api/${eventVaultId}/invitation`

  const response = await axios.delete(endpoint, { data: { email } })

  return response.data?.Message
}

const DELETE_CO_HOST_KEY = "deleteCoHost"

export function useDeleteCoHost(eventVaultId?: number) {
  return useMutation({
    mutationKey: [DELETE_CO_HOST_KEY],
    mutationFn: (email?: string) => deleteCoHost(eventVaultId, email),
  })
}
